import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  systemConfigApi,
  type PatchSystemConfigBody,
  type SystemConfigListResponse,
  type TierThresholdsHistoryRow,
} from './system-config.api';

const LIST_KEY = ['admin', 'system-config'] as const;
const HISTORY_KEY = (key: string) => ['admin', 'system-config', key, 'history'] as const;

export function useSystemConfigList() {
  return useQuery<SystemConfigListResponse>({
    queryKey: LIST_KEY,
    queryFn: () => systemConfigApi.list(),
    staleTime: 30_000,
  });
}

export function useTierThresholdsHistory(key: string, opts: { enabled?: boolean } = {}) {
  return useQuery<{ items: TierThresholdsHistoryRow[] }>({
    queryKey: HISTORY_KEY(key),
    queryFn: () => systemConfigApi.history(key),
    enabled: opts.enabled !== false && key.length > 0,
    staleTime: 60_000,
  });
}

export function usePatchSystemConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { key: string; body: PatchSystemConfigBody }) =>
      systemConfigApi.patch(vars.key, vars.body),
    onSuccess: (_d, vars) => {
      void qc.invalidateQueries({ queryKey: LIST_KEY });
      void qc.invalidateQueries({ queryKey: HISTORY_KEY(vars.key) });
    },
  });
}
